import { render, staticRenderFns } from "./MoleculePartner.vue?vue&type=template&id=3b82616c&scoped=true&"
import script from "./MoleculePartner.vue?vue&type=script&lang=js&"
export * from "./MoleculePartner.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePartner.vue?vue&type=style&index=0&id=3b82616c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82616c",
  null
  
)

export default component.exports